import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Checkbox from 'antd/lib/checkbox';
import { OpenFileLink } from '../../../../common/components/data-display';
import { Row } from 'antd/lib/index';

@translate()
export default class SignBlock extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    fileLocation: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    checkboxText: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    fileLinktext: PropTypes.string.isRequired,
    onChecked: PropTypes.func.isRequired,
    isChecked: PropTypes.bool.isRequired,
    isDisabled: PropTypes.bool,
  };

  onChecked = e => {
    this.props.onChecked(e.target.checked);
  };

  render() {
    const {
      isLoading,
      t,
      fileLocation,
      title,
      text,
      checkboxText,
      fileLinktext,
      isChecked,
      isDisabled,
    } = this.props;

    let linkText = fileLinktext || t('Prečítať zmluvu');

    return (
      <div>
        <Row style={{ marginBottom: '10px' }}>
            <div className='loading'>{isLoading ? 'loading' : null}</div>
            <h3 className='title'>{title}</h3>
        </Row>
        <Row>
            <div>
                <p>{ text }</p>
            </div>
        </Row>
        <Row style={{ marginBottom: '10px' }}>
            <div className="flex-space-between modal-actions">
                <Checkbox 
                    onChange={this.onChecked}
                    checked={isChecked}
                    disabled={isDisabled}
                    className="agreement"
                >
                    { checkboxText }
                </Checkbox>
                <OpenFileLink href={fileLocation}>{linkText}</OpenFileLink>
            </div>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/dashboard/components/registration-action-alert/SignBlock.js